interface ParsedUnc {
  profile: string;
  region: string;
  country: string;
  tadig: string;
  mcc: string;
  mnc: string;
}

/**
 * Parses a Universal Network Code (UNC) string into its component segments
 * @param unc - UNC string in format [profile]-[region]-[country]-[tadig]-[mcc]-[mnc]
 * @returns Object containing parsed UNC segments
 */
const parseUnc = (unc: string): ParsedUnc | null => {
  if (!unc) return null;

  const segments = unc.split('-');
  if (segments.length !== 6) return null;

  const [profile, region, country, tadig, mcc, mnc] = segments;

  return {
    profile,
    region,
    country,
    tadig,
    mcc,
    mnc,
  };
};

export default parseUnc;
